import { Col } from 'react-bootstrap';

import styles from './BriefingThumb.module.css';
import getExtension from '../../helpers/getExtension';
import iconPdf from '../../assets/img/pdf.jpeg';
import iconAvi from '../../assets/img/avi.png';
import iconExcel from '../../assets/img/excel.jpeg';
import iconMov from '../../assets/img/mov.png';
import iconMp4 from '../../assets/img/mp4.png';
import iconTxt from '../../assets/img/txt.png';
import iconWord from '../../assets/img/word.png';

const BriefingThumb = props => {
  return (
    <Col sm={4}>
      {props.briefingArquivo && getExtension(props.briefingArquivo.name) === 'pdf' &&
        <img
          src={iconPdf}
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }

      {props.briefingArquivo && (getExtension(props.briefingArquivo.name) === 'doc' || getExtension(props.briefingArquivo.name) === 'docx') &&
        <img
          src={iconWord}
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }

      {props.briefingArquivo && (getExtension(props.briefingArquivo.name) === 'xls' || getExtension(props.briefingArquivo.name) === 'xlsx') &&
        <img
        src={iconExcel}
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }

      {props.briefingArquivo && getExtension(props.briefingArquivo.name) === 'txt' &&
        <img
          src={iconTxt}
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }

      {props.briefingArquivo && getExtension(props.briefingArquivo.name) === 'mp4' &&
        <img
          src={iconMp4}
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }

      {props.briefingArquivo && getExtension(props.briefingArquivo.name) === 'avi' &&
        <img
          src={iconAvi}
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }

      {props.briefingArquivo && getExtension(props.briefingArquivo.name) === 'mov' &&
        <img
          src={iconMov}
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }

      {props.briefingArquivo &&
        getExtension(props.briefingArquivo.name) !== 'pdf' &&
        getExtension(props.briefingArquivo.name) !== 'doc' &&
        getExtension(props.briefingArquivo.name) !== 'docx' &&
        getExtension(props.briefingArquivo.name) !== 'xls' &&
        getExtension(props.briefingArquivo.name) !== 'xlsx' &&
        getExtension(props.briefingArquivo.name) !== 'txt' &&
        getExtension(props.briefingArquivo.name) !== 'mp4' &&
        getExtension(props.briefingArquivo.name) !== 'avi' &&
        getExtension(props.briefingArquivo.name) !== 'mov' &&
        <img
          src={URL.createObjectURL(props.briefingArquivo)}
          alt={props.briefingArquivo.name}
          className={styles.file_thumb}
        />
      }
    </Col>
  );
};

export default BriefingThumb;
